define(function(require) {
	return {
		card:{
			title: "Default Title",
			cardClass: "default-class",
			numColumns: 2,
			data:[
			]
		},
		field:{
			localizedDescription: "A Localization name",
			description:"Default Description",
			value: "Default Value",
			attributeName: "",
			columnWidth: 1,
			descriptionClass: "default-description-class",
			valueClass: "default-value-class",
			editOptions: {
				editable:false,
			},
			dataType: "string"
		}
	};
});